const CAST_ERROR_CODES = {
  CANCEL: 'The operation was canceled by the user.',
  TIMEOUT: 'The operation timed out.',
  API_NOT_INITIALIZED: 'The API is not initialized.',
  INVALID_PARAMETER: 'The parameters to the operation were not valid.',
  EXTENSION_NOT_COMPATIBLE: 'The API script is not compatible with the installed Cast extension.',
  EXTENSION_MISSING: 'The Cast extension is not available.',
  RECEIVER_UNAVAILABLE: 'No receiver was compatible with the session request.',
  SESSION_ERROR: 'A session could not be created, or a session was invalid.',
  CHANNEL_ERROR: 'A channel to the receiver is not available.',
  LOAD_MEDIA_FAILED: 'Load media failed.',
};

interface CastErrorOptions {
  sessionId: string;
  cause?: unknown;
}

export class CastError extends Error {
  public readonly sessionId: string;
  public readonly cause?: unknown;

  constructor(message: string, options: CastErrorOptions) {
    super(message);

    try {
      const parsedMessage = JSON.parse(message);
      const mappedMessage = CAST_ERROR_CODES[parsedMessage.toUpperCase()];

      if (typeof parsedMessage === 'string' && mappedMessage !== undefined) {
        this.message = mappedMessage;
      }
    } catch {
      const mappedMessage = CAST_ERROR_CODES[message.toUpperCase()];

      if (mappedMessage !== undefined) {
        this.message = mappedMessage;
      }
    }

    this.sessionId = options.sessionId;
    this.cause = options.cause;
    Object.setPrototypeOf(this, new.target.prototype);
  }
}

export class CastingDisabledError extends CastError {}
